<template>
<div class="pagination">
  <span v-if="pager.total === 0" class="count">{{ pager.total }} 件</span>
  <div v-else>
    <span class="count">{{ pager.total }} 件中 {{ pager.offset + 1 }}〜{{ pager.offset + pager.count }}件を表示中</span>
    <span class="prev" @click="prev()" :class="{'active': pager.hasPrev()}">&lt;&lt; 前の{{ pager.limit }}件へ</span>
    |
    <span class="next" @click="next()" :class="{'active': pager.hasNext()}">次の{{ pager.limit }}件へ &gt;&gt;</span>
  </div>
</div>
</template>

<script>
export default {
    props: {
        pager: {
            required: true
        },
        callback: {
            required: true,
            type: Function
        },
    },
    methods: {
        prev: function() {
            if (this.pager.hasPrev()) {
                this.callback.call(this, this.pager.prev());
            }
        },
        next: function() {
            if (this.pager.hasNext()) {
                this.callback.call(this, this.pager.next());
            }
        }
    }
};
</script>
